import styled from 'styled-components'

type DividerProps = {
  $marginTopPx?: number
  $marginBottomPx?: number
}

export const Divider = styled.span<DividerProps>`
  width: 100vw;
  min-height: 8px;
  max-height: 8px;
  background-color: var(--gray100);

  margin-top: ${({ $marginTopPx }) => ($marginTopPx ? `${$marginTopPx}px` : '0px')};
  margin-bottom: ${({ $marginBottomPx }) => ($marginBottomPx ? `${$marginBottomPx}px` : '0px')};
`
